











































import Vue, { PropType } from "vue";
import { validationMixin } from "vuelidate";

// eslint-disable-next-line
function canSelectOneSideFlagPaper(this: any): boolean {
  return !(
    typeof this.backSideDesignNo !== "undefined" && this.oneSideFlag === "1"
  );
}

export default Vue.extend({
  name: "PrintingPaper",

  mixins: [validationMixin],

  props: {
    printingPaper: {
      type: String
    },
    oneSideFlag: {
      type: String as PropType<"0" | "1">
    },
    backSideDesignNo: {
      type: Number as PropType<number | undefined>
    }
  },

  validations: {
    paper: {
      canSelectOneSideFlagPaper: canSelectOneSideFlagPaper
    }
  },

  computed: {
    paper(): string {
      return this.printingPaper;
    },
    siteUrl(): string {
      return process.env.VUE_APP_SITE_URL;
    }
  },

  methods: {
    paperBtnClick(): void {
      this.$emit("paperBtnClick");
    }
  }
});
